module.exports = __webpack_public_path__ + "static/media/amazon.aaf3cfe7.svg";